"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FusionStrategySchema = exports.FusionStrategy = exports.ScoreMergeStrategySchema = exports.ScoreMergeStrategy = exports.QueryTypeSchema = exports.QueryType = void 0;
const zod_1 = require("zod");
var QueryType;
(function (QueryType) {
    QueryType["Lexical"] = "lexical";
    QueryType["Vector"] = "vector";
    QueryType["Hybrid"] = "hybrid";
})(QueryType || (exports.QueryType = QueryType = {}));
exports.QueryTypeSchema = zod_1.z.nativeEnum(QueryType);
var ScoreMergeStrategy;
(function (ScoreMergeStrategy) {
    ScoreMergeStrategy["Max"] = "max";
    ScoreMergeStrategy["Sum"] = "sum";
    ScoreMergeStrategy["MNZ"] = "mnz";
    ScoreMergeStrategy["First"] = "first";
})(ScoreMergeStrategy || (exports.ScoreMergeStrategy = ScoreMergeStrategy = {}));
exports.ScoreMergeStrategySchema = zod_1.z.nativeEnum(ScoreMergeStrategy);
var FusionStrategy;
(function (FusionStrategy) {
    FusionStrategy["Pooling"] = "pooling";
    FusionStrategy["RRF"] = "rrf";
    FusionStrategy["Interleave"] = "interleave";
})(FusionStrategy || (exports.FusionStrategy = FusionStrategy = {}));
exports.FusionStrategySchema = zod_1.z.nativeEnum(FusionStrategy);
//# sourceMappingURL=query-fusion.js.map